import axios from "axios";

// export const APP_URL = "http://38.242.210.224:8080/ama-bi/api/v1/"; // test ama
// export const APP_URL = "https://87.120.103.120:8080/ama-bi/api/v1/"; // live e re LIVE
// export const APP_URL = "http://95.107.160.199:8080/ama-bi/api/v1/"; // live ama 3
// export const APP_URL = "http://127.0.0.1:8080/ama-bi/api/v1/"; // live ama 2
// export const APP_URL = "https://doamin/ama-bi/api/v1/"; // live ama 2
// swagger test http://38.242.210.224:8080/ama-bi/swagger-ui/#/
// swagger http://95.107.160.199:8080/ama-bi/swagger-ui/# LIVE
// ssh administrator@87.120.103.120 -p 2223
// export const APP_URL = "http://87.120.103.120:8080/ama-bi/api/v1/"; // live 3 ama
export const APP_URL = "https://buletini.ama.gov.al/ama-bi/api/v1/"; // live 3 ama

export default axios.create({
  baseURL: APP_URL,
  headers: {
    "Content-type": "application/json",
  },
});
